import { CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { ConsultButton } from "@/components/Buttons";
import { PLAN_OPTIONS, SAME_SERVICE_NOTE, QUOTE_PROCESS, QUOTE_CTA } from "@/data/site";

export const PlanOptions = () => (
  <div data-testid="plan-options">
    <div className="grid gap-6 md:grid-cols-2">
      {PLAN_OPTIONS.map(([t, d], i) => (
        <Reveal key={t} delay={(i % 2) * 0.1}>
          <article data-testid={`plan-option-${i}`} className="group h-full rounded-[4px] border border-[#14263D]/10 bg-white p-8 transition-colors duration-500 hover:border-[#A52A32]/40">
            <div className="flex items-center justify-between">
              <span className="font-mono text-xs text-[#A52A32]">{String(i + 1).padStart(2, "0")}</span>
              <CalendarCheck className="h-5 w-5 text-[#14263D]/40 transition-colors group-hover:text-[#A52A32]" aria-hidden="true" />
            </div>
            <h3 className="mt-4 font-display text-3xl font-semibold text-[#14263D]">{t}</h3>
            <p className="mt-3 text-base leading-relaxed text-[#5F6B76]">{d}</p>
          </article>
        </Reveal>
      ))}
    </div>
    <p data-testid="same-service-note" className="mt-8 max-w-3xl text-base font-medium leading-relaxed text-[#14263D]">{SAME_SERVICE_NOTE}</p>
  </div>
);

export const QuoteProcess = ({ testId = "quote-process" }) => (
  <Reveal>
    <div data-testid={testId} className="rounded-[4px] bg-[#14263D] p-8 text-white md:p-12 lg:grid lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-8">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#f0b3b7]">Personalized Quotes</p>
        {QUOTE_PROCESS.map((p) => <p key={p} className="mt-5 text-base leading-relaxed text-white/90 md:text-lg">{p}</p>)}
      </div>
      <div className="mt-8 flex items-end lg:col-span-4 lg:mt-0 lg:justify-end">
        <ConsultButton testId={`${testId}-btn`} label={QUOTE_CTA} dark />
      </div>
    </div>
  </Reveal>
);
